import { echartSetOption } from '../echarts-utils';

const pieChartInit = () => {
  const { getColor, getData, rgbaColor } = window.phoenix.utils;
  const $chartEl = document.querySelector('.echart-pie-chart-example');

  if ($chartEl) {
    const userOptions = getData($chartEl, 'echarts');
    const chart = window.echarts.init($chartEl);
    const getDefaultOptions = () => ({
      legend: {
        left: 'left',
        top: 'top',
        itemGap: 10,
        textStyle: {
          color: getColor('text-color-subtle')
        }
      },
      series: [
        {
          type: 'pie',
          radius: window.innerWidth < 530 ? '45%' : '60%',
          label: {
            color: getColor('text-color-subtle')
          },
          labelLine: {
            length2: 15
          },
          center: ['50%', '55%'],
          data: [
            {
              value: 1200,
              name: 'Facebook',
              itemStyle: {
                color: getColor('color-primary')
              }
            },
            {
              value: 1000,
              name: 'Youtube',
              itemStyle: {
                color: getColor('color-danger')
              }
            },
            {
              value: 800,
              name: 'Twitter',
              itemStyle: {
                color: getColor('color-info')
              }
            },
            {
              value: 600,
              name: 'Linkedin',
              itemStyle: {
                color: getColor('color-success')
              }
            },
            {
              value: 400,
              name: 'Github',
              itemStyle: {
                color: getColor('color-warning')
              }
            }
          ],
          emphasis: {
            itemStyle: {
              shadowBlur: 10,
              shadowOffsetX: 0,
              shadowColor: rgbaColor(getColor('text-color-subtle'), 0.5)
            }
          }
        }
      ],
      tooltip: {
        trigger: 'item',
        padding: [7, 10],
        backgroundColor: getColor('background-color-subtle'),
        borderColor: getColor('border-color-default'),
        textStyle: { color: getColor('text-color-emphasis') },
        borderWidth: 1,
        transitionDuration: 0,
        axisPointer: {
          type: 'none'
        }
      }
    });

    const responsiveOptions = {
      xs: {
        series: [
          {
            radius: '45%'
          }
        ]
      },
      sm: {
        series: [
          {
            radius: '60%'
          }
        ]
      }
    };

    echartSetOption(chart, userOptions, getDefaultOptions, responsiveOptions);
  }
};

export default pieChartInit;
